export const SUPPORT_ADMIN_AUTH_FLAG_STORAGE_KEY =
  "dxp-support-admin-auth-flag";

export const readSupportAdminAuthFlagFromStorage = (): boolean => {
  try {
    return localStorage.getItem(SUPPORT_ADMIN_AUTH_FLAG_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

export const writeSupportAdminAuthFlagToStorage = (value: boolean): void => {
  try {
    if (value) {
      localStorage.setItem(SUPPORT_ADMIN_AUTH_FLAG_STORAGE_KEY, "true");
      return;
    }

    localStorage.removeItem(SUPPORT_ADMIN_AUTH_FLAG_STORAGE_KEY);
  } catch {
    // private mode / blocked storage — in-memory only
  }
};

export const clearSupportAdminAuthFlagFromStorage = (): void => {
  writeSupportAdminAuthFlagToStorage(false);
};
